import React from 'react';
import { Link } from 'react-router-dom';
import './Products.scss';

type Product = {
  id: string;
  name: string;
  status: 'live' | 'soon';
  tagline: string;
  description: string;
  to: string;
  accent: string;
};

const PRODUCTS: Product[] = [
  {
    id: 'tably',
    name: 'Tably',
    status: 'live',
    tagline: 'Tu mesa es la nueva caja.',
    description: 'Pedidos por QR para restaurantes y bares.',
    to: '/tably',
    accent: '#F43F5E',
  },
];

const PLACEHOLDERS = [
  { id: 'soon-1' },
  { id: 'soon-2' },
];

const TablyMark: React.FC<{ accent: string }> = ({ accent }) => (
  <span className="product-card__mark" aria-hidden="true">
    <span className="product-card__mark-square">
      <span className="product-card__mark-dot" style={{ background: accent }} />
    </span>
    <span className="product-card__mark-text">tably</span>
  </span>
);

const Products: React.FC = () => {
  return (
    <section className="products">
      <div className="container">
        <div className="products__header">
          <p className="products__label">Productos</p>
          <h2 className="products__title">
            Lo que estamos <span className="gradient-text">construyendo</span>.
          </h2>
        </div>

        <div className="products__grid">
          {PRODUCTS.map((p) => (
            <Link
              key={p.id}
              to={p.to}
              className="product-card product-card--live"
              style={{ ['--product-accent' as string]: p.accent }}
              aria-label={`${p.name}: ${p.tagline}`}
            >
              <div className="product-card__top">
                {p.id === 'tably' && <TablyMark accent={p.accent} />}
                <span className="product-card__status">
                  <span className="product-card__status-dot" />
                  En vivo
                </span>
              </div>

              <div className="product-card__body">
                <h3 className="product-card__tagline">{p.tagline}</h3>
                <p className="product-card__description">{p.description}</p>
              </div>

              <span className="product-card__cta">
                Ver producto
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </span>
            </Link>
          ))}

          {PLACEHOLDERS.map((p) => (
            <div key={p.id} className="product-card product-card--placeholder" aria-hidden="true">
              <div className="product-card__top">
                <span className="product-card__placeholder-mark">
                  <span className="product-card__placeholder-dot" />
                </span>
                <span className="product-card__status product-card__status--soon">
                  Próximamente
                </span>
              </div>
              <div className="product-card__body">
                <h3 className="product-card__tagline product-card__tagline--placeholder">
                  Otro producto en camino.
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
